/*
 * @Description: 主题稿库
 * @Author: pu.yuchun
 * @LastEditors: zhaoqing
 * @Date: 2019-12-03 16:48:33
 * @LastEditTime: 2020-05-08 14:49:51
 */
'use strict';
angular.module('resourceCenterThemeModule', ['resCenterZTRouterModule', 'resourceCenterThemeLeftModule', 'themeQuickPreviewModule']).controller('resourceCenterThemeCtrl', [
    '$scope',
    '$q',
    '$element',
    '$filter',
    '$state',
    '$stateParams',
    '$timeout',
    'trsHttpService',
    'initComDataService',
    'resourceCenterService',
    'resCtrModalService',
    'modalDialog',
    'trsspliceString',
    'globleParamsSet',
    'storageListenerService',
    'trsPrintService',
    'resourceApiService',
    function ($scope, $q, $element, $filter, $state, $stateParams, $timeout, trsHttpService, initComDataService, resourceCenterService, resCtrModalService, modalDialog, trsspliceString, globleParamsSet, storageListenerService, trsPrintService, resourceApiService) {
        initStatus();
        initData();

        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                // 分页信息
                CURRPAGE: 1,
                PAGESIZE: globleParamsSet.setResourceCenterPageSize
            };
            // 图集模式信息
            $scope.childStatus = {
                // 图片数组的string
                checkString: 'IMG_INFO',
                // 图片数组中表示url地址的string
                picString: 'perpicurl',
                originPicUrl: 'imgurl'
            };
            $scope.data = {
                casDataArea: [], // 地区的级联数组
                items: [], // 列表数据
                pic: [], // 微博的图片数据
                previewItems: [], // 数字报版面数据
                headers: [], // 列表头部
                selectedArray: [], // 复选框所选数据
                operFlags: [], // 取签见撤重
                suggestResult: '', // 搜索匹配结果
                suggestContentList: [], // 搜索匹配的内容列表
                itemCounts: 0, // 显示的稿件数量
                channelTypeArr: { // 列表处的来源，如果后台返回来源字段，则根据fadecode转换为相应的渠道名称
                    baijiahao: '百家号',
                    qie: '企鹅号',
                    toutiao: '头条号',
                    tv: '电视台',
                    broadcast: '广播电台',
                },
                // 发布渠道所选数据
                selectedChannel: {}
            };
            $scope.status = {
                channelType: $stateParams.fcode, // 栏目类型
                // isSzbPage: $state.params.fcode === 'szb', //false, //是否为数字报版面布局,如果是数字报，则默认进入数字报版面
                screenWrapSelected: false, // 是否显示更多筛选
                singleGraph: false, // 是否为单图模式
                hasphoto: false, // 是否显示图集
                multiImgsReady: false, // 多图加载完成
                draftSearch: { // 稿件类型下拉框是否展现
                    wz: true,
                    app: true,
                    baijiahao: true,
                    qie: true,
                    toutiao: true,
                    douyin: false,
                    tv: true,
                    broadcast: true,
                    wb: false,
                },
            };
            $scope.basicParams = {
                channelName: 'jtcpg',
                typeName: 'jt_lyzh',
                nodeId: $stateParams.theme
            };
            $scope.params = {
                // 列表参数
                typeid: 'zyzx',
                serviceid: 'jtcpg',
                modelId: 'findFromNavigation',
                fcode: '',
                pageSize: $scope.page.PAGESIZE,
                pageNum: $scope.page.CURRPAGE,
                keyword: {
                    theme: $stateParams.theme,
                    searchType: '0', // 查询类型
                    keywords: '', // 关键词
                    time: '', // 时间范围
                    area: '', // 地域
                    zyzxfield: '', // 主题
                    isOriginal: '', // 是否原创
                    isHead: '', // 是否头版
                    isRead: '', // 是否10w+
                    menuscriptType: '' // 稿件类型
                }
            };
            // 发布渠道
            $scope.allChannels = [];
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            if ($scope.basicParams.nodeId) {
                listenStorage();
                getChannel().then(initDropDown).then(function () {
                    if ($scope.$root && $scope.$root.filterDataBack) {
                        // 判断是否有传递的数据
                        $scope.page = $scope.$root.filterDataBack.page;
                        $scope.data.fromdate = $scope.$root.filterDataBack.fromdate;
                        $scope.data.untildate = $scope.$root.filterDataBack.untildate;
                        $scope.params.keyword = $scope.$root.filterDataBack.paramsKeyword;
                        $scope.params.pageNum = $scope.page.CURRPAGE;
                        $scope.params.pageSize = $scope.page.PAGESIZE;
                        $scope.docType = $scope.$root.filterDataBack.docType; // 当前稿件类型
                        $scope.themeType = $scope.$root.filterDataBack.themeType; // 当前主题
                        $scope.keyType = $scope.$root.filterDataBack.keyType; // 当前检索信息
                        $scope.status.hasphoto = $scope.$root.filterDataBack.hasphoto; // 是否图集稿
                        // 默认展开更多筛选项
                        if ($scope.docType.curValue.value != '' || $scope.$root.filterDataBack.area != undefined) {
                            $scope.status.screenWrapSelected = true;
                        }
                        if ($scope.$root.filterDataBack.area) {
                            $scope.data.casDataArea.push($scope.$root.filterDataBack.area[0]);
                        }
                        if ($scope.$root.filterDataBack.listData) {
                            // 是否图集稿，是则直接传递图集列表数据
                            $scope.status.hasphoto = true;
                            // $scope.status.isSzbPage = false;
                            $scope.data.items = $scope.$root.filterDataBack.listData;
                            $scope.status.singleGraph = $scope.$root.filterDataBack.singleGraph; // 是否单图
                            storageListenerService.previewPageTurningStorage($scope.data.items, 'ZB_GUID', 'resourceDetail');
                            getImgList(angular.copy($scope.data.items));
                        } else {
                            requestData();
                        }
                    } else {
                        requestData();
                    }
                    $scope.$on('$destroy', function () {
                        // 销毁对象
                        delete $scope.$root.filterDataBack;
                    });
                });
            }
        }

        /**
         * 获取渠道
         * @return  {[type]} [return description]
         */
        function getChannel() {
            const defer = $q.defer();
            const params = {
                typeid: 'zyzx',
                modelid: 'getProductRoot',
                serviceid: 'navigation',
                excludeId: 'navigation_004006;navigation_004005;navigation_004004',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then((data) => {
                if (data && angular.isArray(data.content) && data.content.length > 0) {
                    $scope.allChannels = data.content.map((item) => {
                        item.value = item.fcode;
                        return item;
                    });
                    $scope.status.channelType = $scope.allChannels[0].value;
                    $scope.data.selectedChannel = $scope.allChannels[0];
                }
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenResource(function () {
                requestData();
                storageListenerService.removeListener('resource');
            }, $scope);
        }

        /**
         * [initDropDown description] 下拉框初始化
         * @return {[type]} [description]
         */
        function initDropDown() {
            var defer = $q.defer();
            // 全部稿件
            $scope.docType = {
                data: initComDataService.newsType(),
                curValue: initComDataService.newsType()[0]
            };
            // 检索字段
            $scope.keyType = {
                data: initComDataService.searchBigdataType(),
                curValue: initComDataService.searchBigdataType()[0]
            };
            // 所有主题
            var themeParams = {
                serviceid: 'navigation',
                typeid: 'zyzx',
                modelid: 'base',
                parentId: '-1',
                level: '2',
                excludeId: '-1',
                containParent: false,
                channelName: 'jtcpg',
                typeName: 'zyzxfield'
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), themeParams, 'post').then(function (themeData) {
                $scope.themeType = {
                    data: [{ dictName: '所有领域', id: '' }].concat(themeData),
                    curValue: { dictName: '所有领域', id: '' }
                };
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [requestData description]test数据请求1
         * @return {[type]} [description]
         */
        function requestData() {
            $scope.data.selectedArray = [];
            var params = angular.copy($scope.params);
            params.keyword = JSON.stringify(params.keyword);
            params.fcode = $scope.data.selectedChannel.value;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function (data) {
                $scope.data.headers = data.summary_info ? data.summary_info.hybaseField : [];
                $scope.data.indexName = data.summary_info ? data.summary_info.indexName : '';
                for (var i = 0; i < $scope.data.headers.length; i++) {
                    if ($scope.data.headers[i].FIELDCNNAME == '来源') {
                        $scope.data.headers[i].FIELDCNNAME = ($scope.status.channelType == 'szb' && '报纸') || ($scope.status.channelType == 'wz' && '网站') || ($scope.status.channelType == 'app' && '客户端') || ($scope.status.channelType == 'wx' && '公众号') || ($scope.status.channelType == 'website' && '媒体') || $scope.data.channelTypeArr[$scope.status.channelType] || '';
                        break;
                    }
                }
                $scope.page = data.summary_info;
                if (!$scope.status.hasphoto) {
                    $scope.data.items = data.content;
                    findReprintCounts();
                } else {
                    $scope.data.itemCounts = 0;
                    $scope.status.multiImgsReady = false;
                    $scope.data.items = $scope.data.items.concat(data.content);
                }
                storageListenerService.previewPageTurningStorage(data.content, 'ZB_GUID', 'resourceDetail');
                getImgList(data.content);
            });
            // }
        }

        /**
         * [initOperFlag description] 初始化取签见撤重
         * @return {[type]} [description]
         */
        function initOperFlag() {
            var docIds = trsspliceString.spliceString($scope.data.items, 'ZB_GUID', ',');
            if (docIds) {
                var params = {
                    methodname: 'queryFlag',
                    serviceid: 'mlf_bigdataexchange',
                    guids: docIds
                };
                params = angular.extend(params, $scope.basicParams);
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    $scope.data.operFlags = [];
                    var temp = data;
                    for (var i in temp) {
                        if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                            $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                        }
                    }
                });
            }
            $scope.data.selectedArray = [];
        }

        /**
         * [findReprintCounts description] 获取转载量
         * @return {[type]} [description]
         */
        function findReprintCounts() {
            var tags = trsspliceString.spliceString($scope.data.items, 'MD5TAG', ',');
            if (!!tags) {
                var params = {
                    typeid: 'zyzx',
                    serviceid: 'jtcpg',
                    modelId: 'findReprintCounts',
                    tags: tags
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function (data) {
                    $timeout(function () {
                        for (var i = 0; i < $scope.data.items.length; i++) {
                            $scope.data.items[i].REPRINTS_COUNT = data.content[0][$scope.data.items[i].MD5TAG];
                        }
                    });
                });
            }
        }

        /**
         * [getImgList description] 请求列表图片
         * @param  {[type]} list [description] 列表数据
         * @return {[type]}      [description]
         */
        function getImgList(list) {
            var docIds = trsspliceString.spliceString(list, 'ZB_GUID', ',');
            if (docIds) {
                var params = {
                    typeid: 'zyzx',
                    modelid: 'getImgList',
                    serviceid: $scope.basicParams.channelName,
                    channelName: $scope.basicParams.channelName,
                    guids: docIds
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function (data) {
                    if (data.result == 'success') {
                        if ($scope.status.channelType == 'wb') {
                            for (var key in data.content[0]) {
                                $scope.data.pic[key] = {
                                    urlS: [],
                                    urlM: []
                                };
                                for (var i = 0; i < data.content[0][key].IMAGEURLS.length; i++) {
                                    $scope.data.pic[key].urlS.push(data.content[0][key].IMAGEURLS[i].urlS);
                                    $scope.data.pic[key].urlM.push(data.content[0][key].IMAGEURLS[i].urlM);
                                }
                            }
                        } else {
                            var temp = data.content[0];
                            var index = $scope.status.hasphoto ? ($scope.params.pageNum - 1) * $scope.params.pageSize : 0;
                            for (var j = 0; j < $scope.data.items.length; j++) {
                                var value = $scope.data.items[j];
                                if (!value.imgurl) {
                                    value.width = temp[value.ZB_GUID] && temp[value.ZB_GUID].IMAGEURLS[0].wight;
                                    value.height = temp[value.ZB_GUID] && temp[value.ZB_GUID].IMAGEURLS[0].height;
                                    value.imgurl = temp[value.ZB_GUID] && temp[value.ZB_GUID].IMAGEURLS;
                                }
                            }
                            $scope.status.multiImgsReady = true;
                            for (var k = 0; k < $scope.data.items.length; k++) {
                                if (!$scope.data.items[k].lastLineHide) {
                                    $scope.data.itemCounts++;
                                }
                            }
                        }
                        $timeout(function () {
                            initOperFlag();
                        });
                    }
                });
            }
        }

        /**
         * [filterName description] 处理客户端名字
         * @param   {[type]}  title  [title description]
         * @return  {[type]}         [return description]
         */
        $scope.filterName = function (title) {
            if (typeof title === 'string' && title.indexOf('客户端') > -1) {
                return title.replace('客户端', '');
            } else {
                return title;
            }
        };

        /**
         * [showOperFlag description] 显示取签见撤重标志
         * @param  {[type]} guid      [description] 稿件id
         * @param  {[type]} flagIndex [description] 类型
         * @return {[type]}           [description]
         */
        $scope.showOperFlag = function (guid, flagIndex) {
            var temp = queryItemBYGUID(guid);
            if (!!temp) {
                return queryItemBYGUID(guid).OPERFLAG.substr(flagIndex, 1) == '1';
            } else {
                return false;
            }
        };

        /**
         * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
         * @param  {[type]} guid [description] 稿件id
         * @return {[type]}      [description]
         */
        function queryItemBYGUID(guid) {
            for (var i in $scope.data.operFlags) {
                if (guid == $scope.data.operFlags[i].GUID) {
                    return $scope.data.operFlags[i];
                }
            }
        }

        /**
         * [viewBigDataInfo description] 取签见撤重 点击弹出
         * @param   {[type]}  ChnlDocId   [ChnlDocId description] 稿件id
         * @param   {[type]}  showRepeat  [showRepeat description] 类型
         * @param   {[type]}  showClick   [showClick description]
         * @return  {[type]}              [return description]
         */
        $scope.viewBigDataInfo = function (ChnlDocId, showRepeat, showClick) {
            var operFlags = queryItemBYGUID(ChnlDocId).OPERFLAG;
            resCtrModalService.bigDataInfoModal(ChnlDocId, showRepeat, showClick, operFlags);
        };

        /**
         * [isSzbPage description] 切换数字报版面样式
         * @return {Boolean} [description]
         */
        $scope.isSzbPage = function () {
            $scope.$broadcast('getTrsHeight');
            // $scope.status.isSzbPage = !$scope.status.isSzbPage;
            // 重置状态
            $scope.themeType.curValue = $scope.themeType.data[0];
            $scope.status.screenWrapSelected = false;
            $scope.status.hasphoto = false;
            $scope.keyType.curValue = $scope.keyType.data[0];
            $scope.docType.curValue = $scope.docType.data[0];
            $scope.data.casDataArea = [];
            $scope.params.keyword = {
                searchType: '0', // 查询类型
                keywords: '', // 关键词
                time: '', // 时间范围
                area: '', // 地域
                zyzxfield: '', // 主题
                isOriginal: '', // 是否原创
                isHead: '', // 是否头版
                isRead: '', // 是否10w+
                menuscriptType: '' // 稿件类型
            };
            // $scope.data.fromdate = "";
            // $scope.data.untildate = "";
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: globleParamsSet.setResourceCenterPageSize,
            };
            $scope.data.items = [];
            $scope.data.previewItems = [];
            requestData();
        };

        /**
         * [quickPreview description] 快速预览模式
         * @return {[type]} [description]
         */
        $scope.quickPreview = function () {
            $scope.$root.filterData = {
                page: $scope.page, // 分页
                fromdate: $scope.data.fromdate, // 开始时间
                untildate: $scope.data.untildate, // 结束时间
                paramsKeyword: $scope.params.keyword, // 其他条件
                area: $scope.data.area, // 地域信息
                docType: $scope.docType, // 当前稿件类型
                themeType: $scope.themeType, // 当前主题
                keyType: $scope.keyType // 当前检索信息
            };
            if ($scope.status.hasphoto) {
                // 是否图集稿，是则直接传递图集列表数据
                $scope.$root.filterData.listData = $scope.data.items;
                $scope.$root.filterData.singleGraph = $scope.status.singleGraph; // 是否单图
            }
            $state.go('front.resourcectrl.theme.quickpreview', $stateParams);
        };

        /**
         * [searchWithKeyword description] 根据条件筛选稿件
         * @param  {[type]} key   [description] 筛选类型
         * @param  {[type]} value [description] 筛选内容
         * @return {[type]}       [description]
         */
        $scope.searchWithKeyword = function (key, value) {
            if (key == 'time') {
                value = $scope.data.untildate ? $filter('date')($scope.data.fromdate, 'yyyy-MM-dd') + ',' + $filter('date')($scope.data.untildate, 'yyyy-MM-dd') : ''; // $filter('date')($scope.data.fromdate, 'yyyy/MM/dd').toString() ? $filter('date')($scope.data.fromdate, 'yyyy/MM/dd').toString() + "," + $filter('date')($scope.data.untildate, 'yyyy/MM/dd').toString() : "";
            } else if (key == 'area') {
                $scope.data.area = angular.copy(value);
                value = value[0][value.length - 1].id;
            }
            $scope.params.keyword[key] = value;
            if (key == 'menuscriptType' && value != '2') {
                $scope.status.hasphoto = false;
            } else if (key == 'menuscriptType' && value == '2') {
                $scope.status.hasphoto = true;
            }
            $scope.params.keyword.searchType = $scope.keyType.curValue.value;
            $scope.params.pageNum = $scope.page.CURRPAGE = 1;
            $scope.data.items = [];
            requestData();
        };

        /**
         * [showSelectedArea description] 数据地域信息的级联菜单获取数据
         * @param  {[type]} node [description] 当前节点
         * @return {[type]}      [description]
         */
        $scope.showSelectedArea = function (node) {
            var deffer = $q.defer();
            resourceCenterService.getArea(node).then(function (data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        };

        /**
         * [pageChanged description] 分页1
         * @return {[type]} [description]
         */
        $scope.pageChanged = function () {
            $scope.params.pageNum = $scope.page.CURRPAGE;
            requestData();
            resourceCenterService.scrollTop($element);
        };

        /**
         * [selectAll description] 全选
         * @return {[type]} [description]
         */
        $scope.selectAll = function () {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [selectDoc description] 单选
         * @param  {[type]} item [description] 当前数据
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function (item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        /**
         * [singleGraphMode description] 是否为单图模式
         * @return {[type]} [description]
         */
        $scope.singleGraphMode = function () {
            $scope.data.items = [];
            $scope.status.singleGraph = !$scope.status.singleGraph;
            $scope.params.pageNum = $scope.page.CURRPAGE = 1;
            requestData();
        };

        /**
         * [loadMore description] 图集-加载更多图片
         * @return {[type]} [description]
         */
        $scope.loadMore = function () {
            $scope.params.pageNum++;
            requestData();
        };

        /**
         * [dealPic description] 数字报版面样式-重新拷贝图片路径并加上随机数，使每次发起不同的请求
         * @return {[type]} [description]
         */
        $scope.dealPic = function (item) {
            item.JPGPATH = item.JPGPATH + '?random=' + Math.random();
        };

        /**
         * [toPreviewDetail description]数字报版面样式-初始化请求数据
         * @return {[type]} [description] null
         */
        $scope.toPreviewDetail = function (item) {
            var router;
            router = $state.href('digitaldetailjtcpg', {
                nodeid: item.ZB_ERTICAL, // $stateParams.fcode
                bc: item.BC,
                docpubtime: item.PUBTIME,
                serviceid: $scope.params.serviceid,
                papername: item.ZB_SOURCE_SITE
            });
            window.open(router + '&' + Math.random());
        };

        /**
         * [goDetail description] 微博-打开详情页
         * @param  {[type]} item [description] 当前数据
         * @return {[type]}      [description]
         */
        $scope.goDetail = function (item) {
            var detail = $state.href('resourcedetail', {
                guid: item.ZB_GUID,
                channel: 'jtcpg'
            });
            window.open(detail);
        };

        /**
         * [openUrl description] 微博-查看原微博
         * @param  {[type]} url [description]
         * @return {[type]}     [description]
         */
        $scope.openUrl = function (url) {
            // var resultUrl = !url.indexOf('http://') ? url : 'http://' + url;
            window.open(url);
        };

        /** ---------------搜索匹配开始-------------- */
        /**
         * [getSuggestResult description]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.getSuggestResult = function (item) {
            $scope.params.keyword.keywords = '';
            getSuggestResult(item);
        };

        /**
         * [getSuggestResult description] 获取搜索建议结果
         * @param  {[type]} item [description] 搜索结果
         * @return {[type]}      [description]
         */
        function getSuggestResult(item) {
            if (!isContain($scope.data.suggestContentList, item) && item) {
                item.type = item.dicttype == 'area' ? 'area' : item.dicttype == 'zyzxfield' ? 'zyzxfield' : 'account';
                $scope.data.suggestContentList.push(item);
                FormatSuggestParams();
                $scope.params.pageNum = $scope.page.CURRPAGE = 1;
                $scope.data.items = [];
                requestData();
            }
        }

        /**
         * [showOperFlag isArrayContain] 判断数组重复性
         * @param  {[type]} list [description] 数组
         * @param  {[type]} item [description] 匹配对象
         * @return {[type]}      [description]
         */
        function isContain(list, item) {
            var temp = false;
            angular.forEach(list, function (value, key) {
                if (value.dictid == item.dictid) {
                    temp = true;
                    return;
                }
            });
            return temp;
        }

        /**
         * [FormatSuggestParams description] 格式化搜索推荐参数
         */
        function FormatSuggestParams() {
            var paramObj = {},
                list = $scope.data.suggestContentList;
            if (list.length) {
                angular.forEach(list, function (value, key) {
                    if (!paramObj[value.type]) {
                        paramObj[value.type] = [];
                    }
                    paramObj[value.type].push(value.dictid);
                });
            }
            $scope.params.keyword = angular.extend($scope.params.keyword, {
                area: (paramObj.area && paramObj.area.join(',')) || '',
                zyzxfield: (paramObj.zyzxfield && paramObj.zyzxfield.join(',')) || '',
                account: (paramObj.account && paramObj.account.join(',')) || ''
            });
        }

        /**
         * [removeItem description] 移除选中的检索词
         * @param  {[type]} index [description] 检索词所在index
         * @param  {[type]} list  [description] 所有检索词
         * @return {[type]}       [description]
         */
        $scope.removeItem = function (index, list) {
            list.splice(index, 1);
            FormatSuggestParams();
            $scope.params.pageNum = $scope.page.CURRPAGE = 1;
            $scope.data.items = [];
            requestData();
        };

        /** ---------------搜索匹配结束-------------- */

        /** --------- 稿件操作开始 --------- */
        /**
         * [openTakeDraftModal description]取稿
         * @return {[type]} [description]
         */
        $scope.openTakeDraftModal = function () {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'fetch',
                guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ',')
            };
            params = angular.extend(params, $scope.basicParams);
            var isOnlyOne = !($scope.data.selectedArray.length > 1);
            var modalInstance = resCtrModalService.fullTakeDraft(params, isOnlyOne, $scope.data.selectedArray);
            modalInstance.result.then(
                function (data) {
                    takeDraftDownloadImgs(data).then(function () {
                        initOperFlag();
                    });
                },
                function () {
                    initOperFlag();
                }
            );
        };

        /**
         * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
         * @param  {[type]} data [description]
         * @return {[type]}      [description]
         */
        function takeDraftDownloadImgs(data) {
            var deferred = $q.defer();
            var needDownloadImg = false;
            for (var i = 0; i < data.REPORTS.length; i++) {
                if (data.REPORTS[i].PICERROR == 1) {
                    needDownloadImg = true;
                    break;
                }
            }
            if (needDownloadImg) {
                resCtrModalService.takeDraftDownloadImgs(data, function (res) {
                    deferred.resolve();
                });
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        /**
         * [CreationAxis description] 个人素材
         */
        $scope.CreationAxis = function () {
            var params = angular.copy($scope.basicParams);
            params.guid = trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ',');
            resourceCenterService.setBigDataCreation(params).then(function (data) {
                modalDialog.alertType('添加成功', '', 'success', false);
                $scope.data.selectedArray = [];
            });
        };

        /**
         * [videoDraftFilter description] 视频稿件过滤器
         * @param   {[type]}  elm  [elm description]
         * @return  {[type]}       [return description]
         */
        $scope.videoDraftFilter = function (elm) {
            if (elm) {
                return elm.DOC_TYPE === '7';
            }
        };

        /**
         * [examvideoDraft description] 视频稿件检查
         * @param   {[string]}  type  [type description] 操作类型
         * @return  {[type]}          [return description]
         */
        function examvideoDraft(type) {
            var defer = $q.defer();
            var temp = $filter('pick')($scope.data.selectedArray, $scope.videoDraftFilter);
            if (temp.length) {
                modalDialog.alertType('操作失败', '视频稿不支持' + type, 'warning', false, '');
                defer.reject();
            } else {
                defer.reslove();
            }
            return defer.promise;
        }

        /**
         * [printbtn description] 打印
         * @return {[type]} [description]
         */
        $scope.printbtn = function () {
            examvideoDraft('打印').then(() => {
                var params = {
                    serviceid: 'jtcpg',
                    modelid: 'detailData',
                    guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                    channelName: $scope.basicParams.channelName,
                    typeid: 'zyzx',
                    indexName: $scope.page.indexName
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function (data) {
                    trsPrintService.trsPrintBigData(data);
                });
            });
        };

        /**
         * [openReserveDraftModal description] 预留
         * @return {[type]} [description]
         */
        $scope.openReserveDraftModal = function () {
            var resCtrModalServiceModal = resCtrModalService.reserveDraft($scope.data.selectedArray);
            resCtrModalServiceModal.result.then(function (result) {
                delete result.items;
                var params = {
                    serviceid: 'mlf_bigdataexchange',
                    methodname: 'delay',
                    guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ',')
                };
                params = angular.extend(params, $scope.basicParams);
                params = angular.extend(params, result);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                    function (data) {
                        modalDialog.alertType('预留成功!', '', 'success', false, function () {
                            initOperFlag();
                            $scope.data.selectedArray = [];
                        });
                    },
                    function () {
                        initOperFlag();
                        $scope.data.selectedArray = [];
                    }
                );
            });
        };

        /**
         * [canCollect description]判断能否收藏
         *
         * @return  {[type]}  [return description]
         */
        function canCollect() {
            return $scope.data.selectedArray.some(function (item) {
                return item.DOC_TYPE != 1 && item.DOC_TYPE != 2 && item.DOC_TYPE != 7 && item.DOC_TYPE != 4;
            });
        }

        /**
         * [collect description] 收藏
         * @return {[type]} [description]
         */
        $scope.collect = function () {
            if (!$scope.data.selectedArray.length) {
                modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                return;
            }
            if (canCollect()) {
                modalDialog.alertType('只能收藏新闻、图集、视频或者链接稿', '', 'warning', 'confirm', '');
                return;
            }
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'collect',
                guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                indexName: $scope.page.indexName
            };
            params = angular.extend(params, $scope.basicParams);
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                modalDialog.alertType('收藏成功!', '', 'success', false, function () {
                    $scope.data.selectedArray = [];
                });
            });
        };

        /**
         * [export description] 导出
         * @return {[type]} [description]
         */
        $scope.export = function () {
            examvideoDraft('导出').then(() => {
                var params = {
                    serviceid: 'mlf_exportword',
                    methodname: 'exportBigDataDocs',
                    GUIDS: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                    CHANNELNAMES: $scope.basicParams.channelName,
                    indexName: $scope.page.indexName
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    window.open('/wcm/app/file/read_file.jsp?FileName=' + data);
                });
            });
        };

        /** --------- 稿件操作结束 --------- */
        /**
         * [scrollShowMore description] 滚动加载更多
         * @return {[type]} [description]
         */
        $scope.scrollShowMore = function () {
            if ($scope.status.hasphoto) {
                $scope.loadMore();
            }
        };

        /**
         * [jsonToArray description] 将json转换成对象,因为抖音某块后台返回的数据中IR_VIEDO_URL为json格式,不能转换
         * @param   {[type]}  item  [item description] 列表数据中的IR_VIEDO_URL字段
         */
        $scope.jsonToArray = function (item) {
            item.IR_VIEDO_URL = JSON.parse(item.IR_VIEDO_URL);
        };

        /**
         * [showDropDownselect description] 展现稿件类型下拉
         * @return  {[type]}  [return description]
         */
        $scope.showDropDownselect = function () {
            return $scope.status.draftSearch[$scope.status.channelType] || false;
        };
        $scope.goToDetail = function (item) {
            var urlParams = { guid: item.ZB_GUID, channel: 'jtcpg', indexname: $scope.data.indexName };
            var url = $state.href('resourcedetail', urlParams);
            window.open(url);
        }
    }
]);
